// extracted by mini-css-extract-plugin
module.exports = {"content":"ShowMoreText_content__1Dxux","anchor":"ShowMoreText_anchor__2lkvp"};